// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bridge-3"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 16.0004V21.0004M3 16.0004H2M3 16.0004H12M3 16.0004V3M21 16.0004V21.0004M21 16.0004H22M21 16.0004H12M21 16.0004V3M12 16.0004V3M3.5 6.33333L12 12L20.5 6.33333","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Bridge3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bridge-3',
    ref,
    icon: element,
  },
));

Bridge3Icon.displayName = 'Bridge3Icon';

export default Bridge3Icon;
